import { motion } from "framer-motion";
import logo from "@/assets/logo.webp";

const sizes = {
  sm: "h-10 w-10",
  md: "h-16 w-16",
  lg: "h-24 w-24",
  xl: "h-36 w-36",
  "2xl": "h-48 w-48",
};

interface Logo3DProps {
  size?: keyof typeof sizes;
  animate?: boolean;
  glow?: boolean;
  className?: string;
}

const Logo3D = ({ size = "md", animate = true, glow = false, className = "" }: Logo3DProps) => {
  return (
    <motion.div
      className={`inline-flex items-center justify-center ${className}`}
      style={{ perspective: "800px" }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.img
        src={logo}
        alt="Dhivisha Architects Logo"
        className={`${sizes[size]} object-contain ${glow ? "drop-shadow-[0_0_20px_hsl(40,50%,48%,0.4)]" : ""}`}
        animate={
          animate
            ? {
                y: [0, -8, 0],
                rotateY: [0, 5, 0, -5, 0],
              }
            : {}
        }
        transition={
          animate
            ? {
                y: { duration: 3, repeat: Infinity, ease: "easeInOut" },
                rotateY: { duration: 6, repeat: Infinity, ease: "easeInOut" },
              }
            : {}
        }
        whileHover={{
          scale: 1.1,
          rotateY: 15,
          transition: { duration: 0.3 },
        }}
        style={{ transformStyle: "preserve-3d" }}
      />
    </motion.div>
  );
};

export default Logo3D;
